import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51e1b6a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-box" }

import {computed} from 'vue';
import {DateFieldType} from '@/components/business/crud/interface/FieldType';
import dayjs from 'dayjs';
import _ from 'lodash';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateTable',
  props: {
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const value = computed(() => {
  const date = props.data[props.propName];
  if (date !== undefined && date !== null) {
    return dayjs(_.toNumber(date)).format(
        props.widget.format || "YYYY-MM-DD"
    );
  } else {
    return '';
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(value.value), 1))
}
}

})